import React from 'react';
import StockOutPage from './StockOutPage';
import StockOutPageMobile from './StockOutPageMobile';

const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 768;
};

const StockOutPageWrapper: React.FC = () => {
  const [mobile, setMobile] = React.useState(isMobile());

  React.useEffect(() => {
    const handleResize = () => {
      setMobile(isMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mobile ? <StockOutPageMobile /> : <StockOutPage />;
};

export default StockOutPageWrapper; 